(() => {
  const canHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  if (!canHover.matches) return;

  const controlsFor = (carousel) => document.querySelector(
    `[data-hover-carousel-controls][data-carousel-id="${carousel.id}"]`,
  );

  const setActiveSlide = (carousel, index) => {
    const slides = [...carousel.querySelectorAll('.product-card-hover-slide')];
    const controls = controlsFor(carousel);

    if (!slides.length) return;

    const activeIndex = (index + slides.length) % slides.length;
    carousel.dataset.carouselIndex = activeIndex;

    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === activeIndex);
    });

    controls?.querySelectorAll('[data-hover-carousel-index]').forEach((dot, dotIndex) => {
      const isActive = dotIndex === activeIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', String(isActive));
    });
  };

  const loadCarouselImages = (carousel) => {
    if (carousel.dataset.carouselLoaded === 'true') return;

    carousel.dataset.carouselLoaded = 'true';
    const images = [...carousel.querySelectorAll('[data-hover-carousel-image]')];

    Promise.all(images.map((image) => new Promise((resolve) => {
      image.addEventListener('load', resolve, { once: true });
      image.addEventListener('error', resolve, { once: true });
      image.sizes = image.dataset.sizes;
      image.srcset = image.dataset.srcset;
      image.src = image.dataset.src;

      if (image.complete) resolve();
    }))).then(() => {
      carousel.classList.add('is-ready');
      controlsFor(carousel)?.classList.add('is-ready');
      setActiveSlide(carousel, 0);
    });
  };

  document.addEventListener('pointerover', (event) => {
    const carousel = event.target.closest('[data-hover-carousel]');

    if (!carousel || carousel.contains(event.relatedTarget)) return;
    loadCarouselImages(carousel);
  });

  document.addEventListener('click', (event) => {
    const controls = event.target.closest('[data-hover-carousel-controls]');
    const target = event.target.closest('[data-hover-carousel-action], [data-hover-carousel-index]');

    if (!controls || !target) return;

    const carousel = document.getElementById(controls.dataset.carouselId);
    if (!carousel?.classList.contains('is-ready')) return;

    const currentIndex = Number(carousel.dataset.carouselIndex || 0);

    if (target.dataset.hoverCarouselAction === 'previous') {
      setActiveSlide(carousel, currentIndex - 1);
    } else if (target.dataset.hoverCarouselAction === 'next') {
      setActiveSlide(carousel, currentIndex + 1);
    } else {
      setActiveSlide(carousel, Number(target.dataset.hoverCarouselIndex));
    }
  });
})();
